export interface Sector {
  id?: number;
  name: string;
  sector_business_rules_enum?: string;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

export interface SectorFilters {
  id?: number | null;
  name?: string | '';
  is_active?: boolean | '';
  page: number;
  per_page: number;
  sort: string;
  order: string;
}

export const defaultSectorFilters: SectorFilters = {
  page: 1,
  per_page: 10,
  sort: 'id',
  order: 'asc'
};
